<template>
    <b-modal :id="'modal-deletar-pessoa-' + pessoaSelecionado.id" hide-footer centered title="Excluir Pessoa">
        <div v-if="pessoaSelecionado != null">
            <b-col md="12" class="d-flex gap-sm">
                <strong v-if="pessoaSelecionado.cpf">Nome: </strong>
                <strong v-else>Razão Social: </strong>
                <span>{{ pessoaSelecionado.nome ? pessoaSelecionado.nome : pessoaSelecionado.razaoSocial }}</span>
            </b-col>
			<b-col md="12" class="d-flex gap-sm">
                <strong v-if="pessoaSelecionado.cpf">CPF: </strong>
                <strong v-else>CNPJ: </strong>
                <span>{{ pessoaSelecionado.nome ? pessoaSelecionado.nome : pessoaSelecionado.razaoSocial }}</span>
            </b-col>
        </div>
        <div class="d-flex mt-5">
            <b-button variant="outline-danger" class="mx-auto" :disabled="carregando" @click="excluirPessoa">
                <b-spinner class="align-middle" variant="danger" v-if="carregando"></b-spinner>
                <span v-if="!carregando">
                    Excluir
                </span>
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import PessoaService from "../../service/PessoaService.js";

export default {
	name: "ModalExcluirPessoa",
	props: [ "pessoa" ],
	data() {
		return {
			pessoaSelecionado: this.pessoa,
			carregando: false,
		};
	},
	methods: {
		excluirPessoa() {
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			this.carregando = true;
			PessoaService.excluirPessoa(this.pessoaSelecionado.id, usuarioLogado.id)
				.then(() => {
					this.$emit("sucesso");
				})
				.then(() => {
					this.mensagem("Pessoa excluida com sucesso!", "Sucesso", "success");
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível excluir o usuário!", "Erro", "danger");
					}
				})
				.finally(() => {
					this.carregando = false;
					this.$bvModal.hide("modal-deletar-pessoa-" + this.pessoaSelecionado.id);
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/pessoa/ModalExcluirPessoa.vue